export default "__VITE_ASSET__CzylwXf2__"